import AuthGuard from 'app/auth/AuthGuard'
import NotFound from 'app/views/404/NotFound'
import dashboardRoutes from 'app/views/dashboard/DashboardRoutes'
import accountRoutes from 'app/views/account/AccountRoutes'
import TableListingRoutes from 'app/views/table-listing/TableListingRoutes'
import ProfileRoutes from 'app/views/profile/ProfileRoutes'
import MatxLayout from '../components/MatxLayout/MatxLayout'
import { Navigate } from 'react-router-dom'
import {TimeoutLogic} from "app/components/TimeoutLogic";

export const AllPages = () => {
    const all_routes = [
        {
            element: (
                <AuthGuard>
                    <MatxLayout />
                    <TimeoutLogic />
                </AuthGuard>
            ),
            children: [...dashboardRoutes, ...TableListingRoutes, ...ProfileRoutes],
        },
        ...accountRoutes,
        {
            path: '/',
            element: <Navigate to="dashboard/default" />,
        },
        {
            path: '*',
            element: <NotFound />,
        },
    ]

    return all_routes
}
